module.exports = __webpack_public_path__ + "static/media/teepot.4f55d1d5.png";